
import { combineReducers } from "@reduxjs/toolkit";
import programBuilder from "./programBuilder";

const rootReducer = combineReducers({
    programBuilder
})

export default rootReducer;
